<template>
  <div class="home">
    <el-row>
      <el-col class="layout" :span="4">
        <div class="userName">
          <div class="logo-container">
            <div class="logo-icon">
              <i class="iconfont iconlogo"></i>
            </div>
          </div>

          <router-link to="D001" class="system-title" v-on:click="changePage">
            <h2>SFアパレル在庫管理</h2>
            <h3>基幹システム</h3>
          </router-link>
        </div>
        <navBar></navBar>
      </el-col>
      <el-col :span="20">
        <headers></headers>
        <keep-alive v-if="showRouteView" :include="keepAlivePages">
          <router-view />
        </keep-alive>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import eventBus from "@/eventBus.js";
import { keepAlivePages } from "@/router";

// コンポーネントの遅延読み込み（パフォーマンス向上）
const navBar = () => import("./navBar");
const headers = () => import("./headers");
export default {
  name: "home",
  provide() {
    return {
      refreshRouteView: this.refreshRouteView,
    };
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      keepAlivePages,
      showRouteView: true,
    };
  },
  components: {
    navBar: navBar,
    headers: headers,
  },
  mounted: function () {
    // 验证登录状态
    if (this.$route.path === "/") {
      getQAjaxRunJson("rstfld", false, 1, "", "/user/ajaxUser/XRRunInitPage.jsp", false, "", null, true);
    }
  },
  methods: {
    changePage() {
      eventBus.$emit("transmit", "SFアパレル在庫管理基幹システム");
    },
    refreshRouteView() {
      this.showRouteView = false;
      this.$nextTick(() => {
        this.showRouteView = true;
      });
    },
  },
};
</script>
<style>
body {
  background: rgba(242, 245, 248, 1);
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.layout {
  position: relative;
  background: rgba(15, 61, 95, 1);
  height: 100vh;
  .userName {
    width: 100%;
    background: linear-gradient(135deg, rgba(15, 61, 95, 1) 0%, rgba(25, 75, 115, 1) 100%);
    text-align: center;
    height: 85px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .logo-container {
      flex-shrink: 0;
      margin-right: 15px;

      .logo-icon {
        width: 50px;
        height: 50px;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        i {
          font-size: 24px;
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }

    .system-title {
      text-decoration: none;
      color: inherit;
      flex: 1;
      text-align: left;

      h2 {
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
        color: rgba(255, 255, 255, 1);
        margin: 0 0 2px 0;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }

      h3 {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: rgba(255, 255, 255, 0.8);
        margin: 0;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }

      &:hover {
        h2, h3 {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }

  .navBar {
    position: absolute;
    top: 85px;
    bottom: 0px;
    background: rgba(15, 61, 95, 1);
    border-top: 1px solid rgba(255, 255, 255, 0.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue